// Price and date are independent controls: a member can order by one, the
// other, both, or neither. Keeping the catalogue and the param mapping here
// lets StuffedFilters stay presentational and makes both testable without
// rendering.

// Each control's value is a direction, or "" for "don't order by this".
export const PRICE_SORT_OPTIONS = [
  { value: "", labelKey: "No price sorting" },
  { value: "desc", labelKey: "Price: high to low" },
  { value: "asc", labelKey: "Price: low to high" },
];

export const DATE_SORT_OPTIONS = [
  { value: "", labelKey: "No date sorting" },
  { value: "desc", labelKey: "Recently updated" },
  { value: "asc", labelKey: "Least recently updated" },
];

export const NO_SORT = { priceSort: "", dateSort: "" };

// The written API contract documents a single `sorting` field and a single
// `direction`. Ordering by both at once therefore sends a comma-separated
// pair with price as the primary key — UNVERIFIED against the live API,
// which was down when this was written. One-field ordering matches the
// documented contract exactly.
//
// Returns null when neither control is set, so the caller omits the params
// and lets the server apply its own default rather than asserting an order.
export const sortParams = ({ priceSort, dateSort } = {}) => {
  const fields = [];
  const directions = [];
  if (priceSort) {
    fields.push("price");
    directions.push(priceSort);
  }
  if (dateSort) {
    fields.push("modified");
    directions.push(dateSort);
  }
  if (fields.length === 0) {
    return null;
  }
  return { sorting: fields.join(","), direction: directions.join(",") };
};
